import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import ReviewActions from '../Redux/ReviewRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getReviews (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getReviewList, token, action.filter)
      if (!res.ok) {
        yield put(ReviewActions.reviewListFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const data_with_page = {
            list: res.data.data,
            page,
            total
          }
          yield put(ReviewActions.reviewListSuccess(data_with_page))
        } else {
          yield put(ReviewActions.reviewListFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(ReviewActions.reviewListFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
  }
}

export function * approveReview (api, action) {
  yield baseFetchToken(api.approveReview,
    action.id,
    getToken,
    ReviewActions.reviewApproveSuccess,
    ReviewActions.reviewApproveFailure)
}



// WEBPACK FOOTER //
// ./src/Sagas/ReviewSagas.js